import { Helmet } from 'react-helmet-async';

const defaultMeta = {
  title: 'Gawkari Hillside | Nature-Focused Farm Experiences',
  description: 'Gawkari is a modern agro-tourism getaway offering immersive farm stays, day picnics, and curated experiences inspired by rural living.',
  keywords: ['Gawkari', 'agro tourism', 'farm stay', 'eco resort', 'day picnic', 'Satara agro tourism', 'rural experiences'],
  siteUrl: 'https://gawkari.com',
  ogImage: '/og-cover.jpg',
};

export function SEO({
  title,
  description = defaultMeta.description,
  keywords = defaultMeta.keywords,
  ogImage = defaultMeta.ogImage,
  canonical,
  type = 'website',
}) {
  const fullTitle = title 
    ? `${title} | Gawkari Hillside`
    : defaultMeta.title;

  const fullOgImage = ogImage.startsWith('http') 
    ? ogImage 
    : `${defaultMeta.siteUrl}${ogImage}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords.join(', ')} />
      
      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={fullOgImage} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="Gawkari Hillside" />
      <meta property="og:locale" content="en_IN" />
      
      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={fullOgImage} />
      
      {/* Canonical URL */}
      {canonical && <link rel="canonical" href={canonical} />}
    </Helmet>
  );
}

export default SEO;
